module.exports = __webpack_public_path__ + "assets/pdf/BN02-en-urban-flood.7557aad1.pdf";